import { YEARLY_TRIAL_PERIOD_DAYS } from 'modules/purchase/constants'

import { TimeInterval } from 'root-constants'

import {
  RECURRING_PERIOD_TO_INTERVAL_MAP,
  TRIAL_PERIOD_TO_INTERVAL_MAP,
} from './constants'

export const getTrialInterval = (
  trialPeriodDays: number,
  periodName: TimeInterval | null,
): { interval: TimeInterval; count: number } => {
  const isYearlyTrial =
    periodName === TimeInterval.YEAR &&
    YEARLY_TRIAL_PERIOD_DAYS.includes(trialPeriodDays)

  if (isYearlyTrial) return { interval: TimeInterval.YEAR, count: 1 }

  return (
    TRIAL_PERIOD_TO_INTERVAL_MAP[trialPeriodDays] ?? {
      interval: TimeInterval.DAY,
      count: trialPeriodDays,
    }
  )
}

export const getRecurringInterval = (
  periodName: TimeInterval | null,
  periodQuantity: number,
): { interval: TimeInterval; count: number } => {
  if (periodName === TimeInterval.MONTH && periodQuantity === 12) {
    return {
      interval: TimeInterval.WEEK,
      count: 52,
    }
  }

  if (periodName === TimeInterval.DAY) {
    return (
      RECURRING_PERIOD_TO_INTERVAL_MAP[periodQuantity] ?? {
        interval: TimeInterval.DAY,
        count: periodQuantity,
      }
    )
  }

  return {
    interval: periodName ?? TimeInterval.MONTH,
    count: periodQuantity,
  }
}
